(ns ncr.etc.hooks
  (:require [uix.core.alpha :as uix]
            [ncr.etc.util :as u]))

(defn- get-matches [query]
  (.-matches (js/window.matchMedia query)))

(defn use-media-query [query]
  (let [*matches (uix/state #(get-matches query))
        update! (fn []
                  (reset! *matches (get-matches query)))]

    (uix/effect!
      (fn []
        (let [media (js/window.matchMedia query)]
          (update!)
          (if (.-addListener media)
            (.addListener media update!)
            (.addEventListener media "change" update!))

          (fn []
            (if (.-removeListener media)
              (.removeListener media update!)
              (.removeEventListener media "change" update!)))))
      [query])

    @*matches))
